var _defs, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShFrame = function SvgShFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "7 7 32 33"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sh_frame_svg__a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.93,
    cy: 23.888,
    r: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m18.49.948 6.169 6.95L6.807 23.744l-6.169-6.95z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.93,
    cy: 23.888,
    r: 16,
    fill: "#E84749",
    mask: "url(#sh_frame_svg__a)"
  })));
};
export { SvgShFrame as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjcgNyAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGRlZnM+CiAgICAgIDxtYXNrIGlkPSJob2xlIj4KPGNpcmNsZSBjeD0iMjIuOTI5NyIgY3k9IjIzLjg4NzciIHI9IjE2IiBmaWxsPSJ3aGl0ZSIvPgogICAgICAgIDxyZWN0IHg9IjE4LjQ5MDIiIHk9IjAuOTQ3NzU0IiB3aWR0aD0iOS4yOTI5IiBoZWlnaHQ9IjIzLjg3MDIiIHRyYW5zZm9ybT0icm90YXRlKDQ4LjQwNzIgMTguNDkwMiAwLjk0Nzc1NCkiIGZpbGw9ImJsYWNrIi8+CiAgICAgIDwvbWFzaz4KICAgIDwvZGVmcz4KPGNpcmNsZSBjeD0iMjIuOTI5NyIgY3k9IjIzLjg4NzciIHI9IjE2IiBmaWxsPSIjRTg0NzQ5IiBtYXNrPSJ1cmwoI2hvbGUpIi8+Cjwvc3ZnPgo=";